import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import Home from "./Home";
import NotFound from "./404";
import Studycase from "./pages/studycase/Studycase";
import ScrollToTop from "./components/ScroolToTop";
import Resume from "./pages/00_resumes/resume/Resume";
import RLresume from "./pages/00_resumes/RLresume/RLresume";
import Blog from "./pages/blog/Blog";
import PostPage from "./pages/blog/PostPage";
// import SecretChat from "./pages/chat/SecretChat";
import Thesis from "./pages/thesis/Thesis";

// ⬇️ Import your custom cursor
import CustomCursor from "./components/CustomCursor";

function App() {
    useEffect(() => {
        const saved = localStorage.getItem("theme") || "light";
        document.body.setAttribute("data-theme", saved);
    }, []);

    return (
        <Router>
            <ScrollToTop />

            {/* ⬇️ Inject your cursor globally */}
            <CustomCursor />

            <Routes>
                <Route path="/" element={<Layout><Home /></Layout>} />
                <Route path="/:slug" element={<Layout><Studycase /></Layout>} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/real-life-resume" element={<RLresume />} />
                <Route path="/thesis" element={<Thesis />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<Layout><PostPage /></Layout>} />
                {/* <Route path="/chat/:room" element={<SecretChat />} /> */}
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound replace />} />
            </Routes>
        </Router>
    );
}

export default App;
